
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m256 340c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm7.7-24h-16c-6.6 0-12-5.4-12-12v-.4c0-70.3 77.4-63.6 77.4-107.4 0-20-17.8-40.2-57.4-40.2-29.1 0-44.3 9.6-59.2 28.7-3.9 5-11.1 6-16.2 2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2 21.1-27.2 46.2-44.7 91.1-44.7 52.3 0 97.4 29.8 97.4 80.2 0 67.4-77.4 63.8-77.4 107.4v.4c0 6.6-5.4 12-12 12zm-7.7-276c118.6 0 216 96.1 216 216 0 119.3-96.6 216-216 216-119.2 0-216-96.6-216-216 0-119.2 96.6-216 216-216m0-32c-137 0-248 111.1-248 248 0 137 111 248 248 248s248-111 248-248c0-136.9-111-248-248-248z"}})])
          )
        }
      }
    